/**
 * v3.15-1161 — Real Prestigious Hub product imagery.
 *
 * Replaces the previous JSX UI mockups with actual cropped screenshots of
 * the live Hub (partner account, sensitive data redacted at capture time).
 * Screenshots live in /public/marketing/ and are referenced by absolute URL.
 *
 * If a future Hub UI change makes a screenshot stale, re-capture from the
 * partner account, redact, and replace the file in place.
 */
const baseImg = 'rounded-lg shadow-soft border border-slate-200 w-full h-auto';

export const HubDashboardScreenshot = ({ className = '' }) => (
  <figure className={className} data-testid="hub-shot-dashboard">
    <img
      src="/marketing/hub-dashboard.jpg"
      alt="Prestigious Hub — Partner Dashboard"
      className={baseImg}
      loading="lazy"
    />
    <figcaption className="mt-2 text-xs uppercase tracking-wider text-slate-400">
      Partner Dashboard · Live screenshot
    </figcaption>
  </figure>
);

export const HubClientsScreenshot = ({ className = '' }) => (
  <figure className={className} data-testid="hub-shot-clients">
    <img
      src="/marketing/hub-clients.jpg"
      alt="Prestigious Hub — Client portfolio with pipeline stage and lender activity"
      className={baseImg}
      loading="lazy"
    />
    <figcaption className="mt-2 text-xs uppercase tracking-wider text-slate-400">
      Client Portfolio · Live screenshot
    </figcaption>
  </figure>
);

export const HubCommunicationsScreenshot = ({ className = '' }) => (
  <figure className={className} data-testid="hub-shot-communications">
    <img
      src="/marketing/hub-activity.jpg"
      alt="Prestigious Hub — Partner-to-Concierge in-platform messaging"
      className={baseImg}
      loading="lazy"
    />
    <figcaption className="mt-2 text-xs uppercase tracking-wider text-slate-400">
      Partner ⇄ Concierge Messaging · Live screenshot
    </figcaption>
  </figure>
);
